import { Injectable } from '@angular/core';
import { Kpi } from '@shared/models';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class KpiBoxService {
  private controlVoice = new Subject<Kpi>();
  public controlVoice$ = this.controlVoice.asObservable();

  private kpis = new BehaviorSubject<Kpi[]>([]);
  public kpis$ = this.kpis.asObservable();

  private notifierHasActualComparisonDataAvailable =
    new BehaviorSubject<boolean>(false);
  private notifierHasPreviousYearDataAvailable = new BehaviorSubject<boolean>(
    false
  );

  public notifierHasPreviousYearDataAvailable$ =
    this.notifierHasPreviousYearDataAvailable.asObservable();
  public notifierHasActualComparisonDataAvailable$ =
    this.notifierHasActualComparisonDataAvailable.asObservable();

  setControlVoice(kpi: Kpi) {
    this.controlVoice.next(kpi);
  }

  setActualComparisonDataAvailability(availability: boolean) {
    this.notifierHasActualComparisonDataAvailable.next(availability);
  }

  setPreviousYearDataAvailability(availability: boolean) {
    this.notifierHasPreviousYearDataAvailable.next(availability);
  }

  public changeKpis(kpis: Kpi[]): void {
    this.kpis.next(kpis);
  }
}
